import http from "@/http"
import {formatUnitTree} from "@/utils/format"
import storage from "@/utils/storage"
import store from "../index";
import {Toast} from "vant";

function isPermiss({to, next}) {
    const permissions = store.getters['global/permissions']
    let isPermiss = true;
    (to.meta.permiss || []).forEach(item => {
        if (!permissions.includes(item)) {
            isPermiss = false;
            console.error('没有该权限', item)
        }
    })
    isPermiss ? next() : Toast.fail("没有权限")
}

const state = {
    clear: false, // 用来标记清除所有信息（登录页触发），登陆成功后该值为true,默认为false，避免死循环
    userInfo: {}, // 用户信息
    permissions: [], // 权限代码
    unitList: [], // 单位列表
    units: [], // 机构单位列表
    unitTree: [], // 机构、单位树
    unitTreeDisOrgans: [], // 禁用机构树
    unitTreeDisUnit: [], // 禁用单位树
    organTree: [], // 机构树
    areaTree: [], // 区域树
    productList: [], // 产品列表
    generalTotal: {}, // 所有统计
};

const actions = {

    reset({state}) {
        if (state.clear) {
            // 清除默认值的缓存
            storage.clearCache('__organ')
            storage.clearCache('__unit')
            storage.clearCache('__area')
            storage.clearCache('__product')

            window.location.reload();
        }

    },
    login({commit, dispatch, getters, rootState, state}, {payload}) {
        const {to, next} = payload
        const isAccount = to.path.startsWith('/account')
        if (isAccount) {
            next()
            return;
        }

        // 判断是否是第一次加载（已有用户信息则直接进行权限验证）
        if (state.clear) {
            isPermiss({to, next})
            // dispatch({type: 'init'}) // 用户觉得请求慢，所以已经存在的资源不再获取
            return;
        }
        http.tokiot.sys.user.getDetail({})
            .then(userInfo => {
                if (userInfo) {
                    dispatch({type: 'setPermissions', permissionCodeList: userInfo.permissionCodeList})
                    dispatch({type: 'init'})
                    commit('Success', {userInfo, clear: true});
                    store.dispatch({type: 'default/init', userInfo})
                    storage.setCache('userInfo', userInfo)
                    isPermiss({to, next})
                }
            })
    },
    init({commit, dispatch, getters, rootState, state}, {payload}) {
        // const data = {};
        // if (payload) {
        //     const {unit} = payload
        //     if (unit) data.unitId = unit.id
        // }
        const defaultUnit = store.getters['default/all'].unitOrOrgan
        dispatch({type: 'loadUnitTree', defaultUnit})
        dispatch({type: 'loadUnitList', defaultUnit})
        dispatch({type: 'loadUnits', defaultUnit})
        dispatch({type: 'loadOrganTree', defaultUnit})
        dispatch({type: 'loadAreaTree', defaultUnit})
        dispatch({type: 'loadProductList', defaultUnit})
        dispatch({type: 'generalTotal', defaultUnit})
        dispatch({type: 'loadDict'})
        dispatch({type: 'loadUicomponent'})
    },
    setPermissions({commit}, {permissionCodeList}) {
        storage.setCache('permissions', permissionCodeList)
        commit('Success', {permissions: permissionCodeList});
    },
    loadDict({commit}) {
        http.tokiot.sys.dict.list({size: 99999})
            .then(ret => {
                if (ret) {
                    const dictList = ret.rows;
                    const DICT = {};
                    let item = {}
                    Object.keys(dictList).map(key => {
                        item = dictList[key];
                        if (DICT[item.type] === undefined) DICT[item.type] = {map: {}, list: []}
                        DICT[item.type].map[item.value] = item.label;
                        DICT[item.type].list.push({code: item.value, codeName: item.label});
                    })
                    storage.setCache('DICT', DICT)
                    commit('Success', {DICT});
                }
            })
    },
    loadUicomponent({commit}) {
        http.tokiot.sys.uicomponent.list({size: 99999, bizType: "COMPONENT"})
            .then(ret => {
                if (ret) {
                    const  uicomponentList = ret.rows
                    storage.setCache('UICOMPONENT', uicomponentList)
                    commit('Success', {uicomponentList});
                }
            })
    },
    generalTotal({commit}, {defaultUnit}) {
        const data = {}
        if (defaultUnit) data.unitId = defaultUnit.id
        http.tokiot.datav.common.totalBase(data)
            .then(generalTotal => {
                if (generalTotal) {
                    commit('Success', {generalTotal});
                }
            })
    },
    loadUnitList({commit}, {defaultUnit}) {
        const data = {size: 99999, type: "Unit"}
        if (defaultUnit) data.id = defaultUnit.id
        http.tokiot.sys.unit.v2.list(data)
            .then(ret => {
                if (ret) {
                    commit('Success', {unitList: ret.rows});
                }
            })
    },
    loadUnits({commit}, {defaultUnit}) {
        const data = {size: 99999}
        if (defaultUnit) data.id = defaultUnit.id
        http.tokiot.sys.unit.v2.list(data)
            .then(ret => {
                if (ret) {
                    commit('Success', {units: ret.rows});
                }
            })
    },
    loadUnitTree({commit}, {defaultUnit}) {
        const data = {}
        if (defaultUnit) data.id = defaultUnit.id
        http.tokiot.sys.unit.v2.tree(data)
            .then(ret => {
                if (ret) {
                    const formatTree = [JSON.parse(
                        JSON.stringify(ret)
                    )];
                    const unitTree = JSON.parse(JSON.stringify(formatTree))
                    const unitTreeDisOrgans = JSON.parse(JSON.stringify(formatTree))
                    const unitTreeDisUnit = JSON.parse(JSON.stringify(formatTree))
                    formatUnitTree(unitTreeDisOrgans, "Organs")
                    formatUnitTree(unitTreeDisUnit, "Unit")
                    commit('Success', {unitTree, unitTreeDisOrgans, unitTreeDisUnit});
                }
            })
    },
    loadOrganTree({commit}, {defaultUnit}) {
        const data = {type: 'Organs'}
        if (defaultUnit) data.id = defaultUnit.id
        http.tokiot.sys.unit.v2.tree(data)
            .then(ret => {
                if (ret) {
                    const organTree = [ret];
                    commit('Success', {organTree});
                }
            })

    },
    loadAreaTree({commit}, {defaultUnit}) {
        const data = {}
        if (defaultUnit) data.id = defaultUnit.areaId
        http.tokiot.sys.area.v2.tree(data)
            .then(ret => {
                if (ret) {
                    const areaTree = [ret]
                    commit('Success', {areaTree});
                }
            })
    },
    loadProductList({commit}, {defaultUnit}) {
        const data = {}
        if (defaultUnit) data.unitId = defaultUnit.id
        http.tokiot.sys.product.listAuthorized(data)
            .then(productList => {
                if (productList) {
                    commit('Success', {productList});
                }
            })
    }
};

const getters = {
    userInfo: state => state.userInfo || storage.getCache('userInfo'),
    permissions: state => state.permissions || storage.getCache('permissions') || [],
    unitList: state => state.unitList,
    units: state => state.units,
    unitTree: state => state.unitTree,
    unitTreeDisOrgans: state => state.unitTreeDisOrgans,
    unitTreeDisUnit: state => state.unitTreeDisUnit,
    organTree: state => state.organTree,
    areaTree: state => state.areaTree,
    productList: state => state.productList,
    generalTotal: state => state.generalTotal,
};

const mutations = {
    Success(state, payload) {
        Object.keys(payload).map(key => {
            state[key] = payload[key]
        })
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
